/* eslint import/prefer-default-export: 0 */
export { default as ApiMixin } from './apiMixin';



// WEBPACK FOOTER //
// ./app/assets/javascripts/mixins/index.jsx